import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, Subject } from 'rxjs';
import { Cacheable, LocalStorageStrategy } from 'ts-cacheable';
import { ScreenApiModel } from '../model/api-model/screen/screen.api.model';

@Injectable({
  providedIn: 'root'
})
export class ScreenHttpService {
  public static cacheBuster$ = new Subject<void>();

  constructor(private http: HttpClient) {}

  @Cacheable({
    storageStrategy: LocalStorageStrategy,
    cacheBusterObserver: ScreenHttpService.cacheBuster$,
    maxAge: 3600000,
    shouldCacheDecider: (response) => {
      return Array.isArray(response) && response !== null && response.length > 0;
    }
  })
  getScreens(cinemaId: string, screeningId: string | null = null): Observable<ScreenApiModel[]> {
    return this.http.get<ScreenApiModel[]>(`/cinema/${cinemaId}/screen`, {
      params: {
        screeningId: screeningId
      }
    });
  }

  @Cacheable({
    cacheBusterObserver: ScreenHttpService.cacheBuster$,
    maxAge: 3600000,
    shouldCacheDecider: (response) => {
      return response !== null && response !== undefined;
    }
  })
  getScreen(cinemaId: string, screenId: string): Observable<ScreenApiModel> {
    return this.http.get<ScreenApiModel>(`/cinema/${cinemaId}/screen/${screenId}`);
  }
}
